import React from "react";
import { useIntl } from "react-intl";
import { StyleSheet } from "react-native";

import BaseComponent from "../BaseComponent";
import Text from "../Text";
import Stack from "../Stack";

type PropsType = {
  fullname: string;
  content: string;
};

const styles = StyleSheet.create({
  label: {
    fontSize: "0.875em" as any,
    fontWeight: "700",
  },
  content: {
    fontSize: "0.875em" as any,
  },
});

const OwnerAnswer: React.FunctionComponent<PropsType> = (props) => {
  const { fullname, content } = props;

  const intl = useIntl();

  return (
    <BaseComponent>
      <Text style={styles.label}>
        {fullname
          ? intl.formatMessage(
              {
                defaultMessage: "Réponse de {fullname}",
              },
              { fullname }
            )
          : intl.formatMessage({
              defaultMessage: "Réponse du propriétaire",
            })}
      </Text>
      <Stack marginTop={0.625} />
      <Text style={styles.content}>{content}</Text>
    </BaseComponent>
  );
};

export default OwnerAnswer;
